// extracted by mini-css-extract-plugin
module.exports = {"link":"UrG2M","image":"_2xP8k","root":"_925yd"};